import { useEffect, useState } from "react";
import { Phone, Mail, Globe, ExternalLink, ShieldCheck, Building2 } from "lucide-react";
import api from "../lib/api";

export default function AirportContacts({ code }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!code) return;
    api.get(`/airports/${code}/contacts`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [code]);

  if (!data || !data.has_contacts) return null;

  return (
    <div className="border border-emerald-300 bg-emerald-50/40 p-5" data-testid="airport-contacts">
      <h3 className="font-heading font-900 text-emerald-700 flex items-center gap-2 mb-1"><ShieldCheck className="w-5 h-5" /> Official airport contacts</h3>
      {data.airport_authority && <div className="text-xs text-muted-foreground flex items-center gap-1.5 mb-3"><Building2 className="w-3.5 h-3.5" /> {data.airport_authority}</div>}

      <div className="space-y-2">
        {data.items.map((c) => (
          <div key={c.key} className="flex items-center gap-2 text-sm" data-testid={`airport-contact-${c.key}`}>
            {c.type === "phone" ? <Phone className="w-4 h-4 text-emerald-600 shrink-0" /> : <Mail className="w-4 h-4 text-emerald-600 shrink-0" />}
            <span className="text-muted-foreground w-32 shrink-0 text-xs">{c.label}</span>
            {c.type === "phone"
              ? <a href={`tel:${c.value}`} className="text-primary hover:underline font-mono">{c.value}</a>
              : <a href={`mailto:${c.value}`} className="text-primary hover:underline break-all">{c.value}</a>}
          </div>
        ))}
      </div>

      <div className="mt-4 flex flex-wrap gap-2">
        {data.airport_website && (
          <a href={data.airport_website} target="_blank" rel="noreferrer" data-testid="airport-website-link" className="inline-flex items-center gap-1.5 bg-emerald-600 text-white px-3 py-2 text-xs font-600 hover:bg-emerald-700">
            <Globe className="w-3.5 h-3.5" /> Official website
          </a>
        )}
        {data.contact_page_url && (
          <a href={data.contact_page_url} target="_blank" rel="noreferrer" data-testid="airport-contact-page-link" className="inline-flex items-center gap-1.5 border border-emerald-300 text-emerald-700 px-3 py-2 text-xs font-600 hover:bg-emerald-50">
            <ExternalLink className="w-3.5 h-3.5" /> Contact page
          </a>
        )}
      </div>
      <p className="text-xs text-muted-foreground mt-3">{data.note}</p>
    </div>
  );
}
